import { IMG_BONOS } from '../utils/constants'

export interface Tomo {
  titulo: string
  descripcion: string
}

export const TOMOS: Tomo[] = [
  {
    titulo: 'Antes del lápiz',
    descripcion:
      'La postura, el agarre y los 8 trazos base. Todavía no hay ni una letra: primero el movimiento.',
  },
  {
    titulo: 'Las letras, una por una',
    descripcion:
      'Las 27 letras agrupadas por movimiento, no por abecedario. Cada una con su error típico y cómo se corrige.',
  },
  {
    titulo: 'De la letra a la palabra',
    descripcion:
      'La unión y el espacio entre palabras, que es donde la letra se vuelve ilegible aunque cada letra esté bien hecha.',
  },
  {
    titulo: 'Frases y renglón',
    descripcion: 'Sostener el renglón en una línea larga, sin que se caiga ni se trepe.',
  },
  {
    titulo: 'Escribir de verdad',
    descripcion:
      'Textos propios que alguien más va a leer: una nota, una lista, una carta. Acá se prueba si funcionó.',
  },
  {
    titulo: 'El plan de 21 días',
    descripcion:
      'Una hoja por día, con qué hacer y qué mirar ese día. Los demás venden hojas: esto es un plan.',
  },
]

export interface Bono {
  titulo: string
  descripcion: string
  valor: string
  img: string
}

export const BONOS: Bono[] = [
  {
    titulo: 'Cuaderno para zurdos',
    descripcion:
      'La inclinación de la hoja, de qué lado poner la luz y el agarre que evita que se manche la mano.',
    valor: '$14.990',
    img: IMG_BONOS[0],
  },
  {
    titulo: 'Qué corregir y qué dejar pasar',
    descripcion:
      'Cuándo marcar un error y cuándo callarse. La mitad de los avances se pierden por corregir de más.',
    valor: '$9.990',
    img: IMG_BONOS[1],
  },
  {
    titulo: 'Cuando escribir cuesta',
    descripcion:
      'Qué hacer si hay resistencia, llanto o dolor de mano. Cuándo conviene consultar y con quién.',
    valor: '$12.990',
    img: IMG_BONOS[2],
  },
  {
    titulo: 'Informe de avance para la escuela',
    descripcion: 'Para mostrarle a la maestra qué cambió, con evidencia y fechas.',
    valor: '$8.990',
    img: IMG_BONOS[3],
  },
  {
    titulo: '50 ejercicios sin lápiz',
    descripcion:
      'Motricidad fina con lo que ya hay en la cocina y el patio, para los días en que no quiere saber nada con el cuaderno.',
    valor: '$9.990',
    img: IMG_BONOS[4],
  },
  {
    titulo: '30 juegos de escritura',
    descripcion: 'Para que practique sin que se sienta tarea.',
    valor: '$8.990',
    img: IMG_BONOS[5],
  },
]

export const PAIN_POINTS: string[] = [
  'La maestra te lo volvió a escribir en el cuaderno de comunicaciones.',
  'Sabe la respuesta, pero le bajan la nota porque no se entiende lo que escribió.',
  'Tarda el triple que los compañeros en copiar del pizarrón.',
  'Le duele la mano a los diez minutos y abandona.',
  'Ya probaste con planas y con retarlo, y lo único que consiguieron fue pelearse.',
  'Es zurdo y nadie te supo decir qué hay que hacer distinto.',
]

export const BENEFICIOS: string[] = [
  'Que se le entienda: letra legible por otra persona, no solo por vos.',
  'Que no se canse: sin dolor de mano ni abandono a los diez minutos.',
  'Que copie al ritmo de la clase, sin quedarse a mitad del pizarrón.',
  'Que la nota refleje lo que sabe, y no cuánto se entiende su letra.',
  'Que dejen de pelearse por el cuaderno: hay un plan, no tenés que inventar qué hacer.',
]

export const PARA_QUIEN_SI: string[] = [
  'Tiene entre 5 y 12 años',
  'Ya escribe pero no se le entiende',
  'Se cansa o le duele la mano',
  'Es zurdo y nadie te supo orientar',
  'Podés sentarte 15 minutos por día con él',
]

export const PARA_QUIEN_NO: string[] = [
  'Buscás que aprenda a leer: esto es sobre escribir',
  'Esperás que lo haga solo, sin ningún acompañamiento',
  'Querés un diagnóstico: esto entrena, no diagnostica',
  'No tenés forma de imprimir las hojas',
]

export interface ComparativaFila {
  concepto: string
  otros: string
  kit: string
}

export const COMPARATIVA: ComparativaFila[] = [
  { concepto: 'Actividades', otros: '400', kit: '633 páginas' },
  { concepto: 'Plan día por día', otros: 'No', kit: '21 días' },
  { concepto: 'Material para zurdos', otros: 'No', kit: 'Sí' },
  { concepto: 'Qué hacer si le cuesta', otros: 'No', kit: 'Sí' },
  { concepto: 'Informe para la maestra', otros: 'No', kit: 'Sí' },
  { concepto: 'Garantía', otros: '7 días', kit: '14 días' },
]

export interface Faq {
  pregunta: string
  respuesta: string
}

export const FAQS: Faq[] = [
  {
    pregunta: '¿Para qué edad sirve?',
    respuesta:
      'De 1º a 6º grado. Los tomos 1 y 2 sirven desde los 5 años; del 3 en adelante hace falta que ya escriba.',
  },
  {
    pregunta: '¿Es impreso o digital?',
    respuesta:
      'Es digital y lo imprimís vos, las veces que quieras. Si el ejercicio no salió, lo volvés a imprimir sin comprar nada.',
  },
  {
    pregunta: '¿Cuánto tiempo por día?',
    respuesta: '15 minutos. Menos no alcanza; más cansa la mano y es contraproducente.',
  },
  {
    pregunta: 'Mi hijo es zurdo.',
    respuesta:
      'Hay un cuadernillo entero para zurdos: la inclinación de la hoja, de qué lado poner la luz y el agarre que evita que se manche la mano.',
  },
  {
    pregunta: '¿Y si tiene un diagnóstico o hace tratamiento?',
    respuesta:
      'Mostráselo a su terapista antes de empezar. Nada de esto interfiere con un tratamiento, pero el orden y el ritmo los tiene que marcar quien lo está viendo.',
  },
  {
    pregunta: '¿Cuándo lo recibo?',
    respuesta: 'Al instante. Terminás de pagar y te llega el acceso por mail.',
  },
  {
    pregunta: '¿Y si no me sirve?',
    respuesta: 'Tenés 14 días para pedir la devolución.',
  },
]

export interface Testimonio {
  texto: string
  nombre: string
  ciudad: string
}

export const TESTIMONIOS: Testimonio[] = [
  {
    texto:
      'A la tercera semana la maestra me escribió, pero para decirme que se le entendía. Nunca me había pasado.',
    nombre: 'Carolina Ferreyra',
    ciudad: 'Posadas, Misiones',
  },
  {
    texto:
      'Lo mejor fue tener una hoja por día. Yo no tenía que pensar qué hacer, ya estaba escrito.',
    nombre: 'Mariano Sosa',
    ciudad: 'Rosario, Santa Fe',
  },
  {
    texto:
      'Mi hija es zurda y se manchaba toda la mano. Con el cuadernillo de zurdos cambió el apoyo en dos días.',
    nombre: 'Verónica Aguirre',
    ciudad: 'Córdoba, Córdoba',
  },
  {
    texto:
      'Dejamos de pelearnos por el cuaderno. Son quince minutos, los hacemos después de merendar y listo.',
    nombre: 'Débora Quiroga',
    ciudad: 'Neuquén, Neuquén',
  },
  {
    texto:
      'Antes copiaba media hoja del pizarrón. Hoy termina con el resto del grado y no le duele la mano.',
    nombre: 'Gustavo Medina',
    ciudad: 'Salta, Salta',
  },
  {
    texto:
      'El informe para la escuela me sirvió muchísimo en la reunión. Fui con fechas y con las hojas de antes y después.',
    nombre: 'Lucía Benítez',
    ciudad: 'La Plata, Buenos Aires',
  },
]
